import React, { useEffect, useContext, useCallback, useMemo } from 'react';

// DEPENDENCIES
import { connect } from 'react-redux';
import { useFormikContext } from 'formik';
import { Link } from 'react-router-dom';
import trim from 'lodash/trim';

// GLOBAL VARIABLES
import { INTERFACE, RECORD } from 'pathnames.js';
import { INVENTORY_STATUS } from '../variables';

// HELPERS
import useRecordView from 'helpers/getRecordView';
import { lookupActions } from 'actions';

// FUNCTIONS
import { makePath } from 'functions.js';

// CONTEXT
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import VinNumberComponent from '../../tools/VinNumber';

// STYLES
import styles from './vinNumber.module.scss';

// MAIN COMPONENT
const OrderVinNumber = connect(({ lookups }) => ({ lookups }), { ...lookupActions })(
  ({
    load, //
    flush,
    makeOption,
    make_ids,
    isNew
  }) => {
    const { isEdit } = useRecordView();
    const { record } = useContext(RecordContext) || {};
    const { values, setValues } = useFormikContext() || {};
    const { vin_num } = useMemo(() => values || {}, [values]);

    useEffect(
      () => {
        return () => {
          flush('exteriorColors');
          flush('interiorColors');
        }
      }, [vin_num, flush]);

    const handleSuccess = useCallback(
      ({
        vehicle_year,
        make_id,
        make_name,
        model,
        model_code,
        vehicle_trim,
        body_style,
        engine,
        engine_type,
        drivetrain_name,
        drivetrain,
        transmission_name,
        ext_color,
        int_color
      }) => {
        setValues({
          ...values,
          vehicle_year,
          make_id: makeOption && isNew ? make_ids : make_id,
          make: make_name,
          model,
          model_code,
          vehicle_trim,
          body_style,
          engine,
          engine_type,
          drivetrain_name: drivetrain_name || drivetrain,
          transmission_name,
          ext_color: '',
          int_color: ''
        });
        load('exteriorColors', ext_color);
        load('interiorColors', int_color);
      },
      [setValues, makeOption, make_ids, load, isNew, values]
    );

    const vinNum = useMemo(() => trim(record?.vin_num), [record]);
    const isSaleOrder = [INVENTORY_STATUS.sold, INVENTORY_STATUS.order].includes(record?.inventory_status_name);
    const orderSalesId = record?.order_sales_id;

    return isEdit && !vinNum ? (
      <Form.PlainText
        label="VIN"
        formGroup={{
          className: styles.group
        }}
        value={
          isSaleOrder && orderSalesId ? (
            <>
              A VIN cannot be added to this vehicle. Please visit the corresponding{' '}
              <Link to={makePath(INTERFACE.order, RECORD.view, orderSalesId)}>order page</Link> and click on "Add VIN"
              there.
            </>
          ) : (
            'A VIN cannot be added to this vehicle.'
          )
        }
      />
    ) : (
      <VinNumberComponent name="vin_num" onSuccess={handleSuccess} required />
    );
  }
);

// EXPORT
export default OrderVinNumber;
